module.exports = __webpack_public_path__ + "img/ico_share--orange.249cbe54.svg";